export const APP_STORE_URL = 'https://apps.apple.com/us/app/teambuildr-training/id1588729407';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.teambuildr.reactnative.android.production';
export const APP_URL_SCHEME = 'teambuildr';
